import { Center } from "@chakra-ui/react";
import FormContainer from "../../CustomUi/FormContainer";
import MultiStepForm from "../../forms/MultiStepForm";

function Register() {
  return (
    <Center>
      <FormContainer
        heading="Create Account"
        description="Create your Result account and get started in minutes"
      >
        <MultiStepForm />
      </FormContainer>
    </Center>
  );
}

export default Register;
